import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, HeartIcon, BookOpenIcon } from 'lucide-react';
import SaveToTracker from '../UI/SaveToTracker';
interface ProductCardProps {
  id: string;
  title: string;
  vendor: string;
  image: string;
  price: number;
  relatedBook?: string;
  isOfficialMerch?: boolean;
  donationInfo?: {
    percentage: number;
    nonprofitName: string;
  };
}
const ProductCard: React.FC<ProductCardProps> = ({
  id,
  title,
  vendor,
  image,
  price,
  relatedBook,
  isOfficialMerch,
  donationInfo
}) => {
  return <Link to={`/product/${id}`} className="group block" data-id="element-3100" data-mp="17zhssgraldjv">
      <div className="relative aspect-square rounded-xl overflow-hidden shadow-sm transition-all duration-300 group-hover:shadow-xl group-hover:-translate-y-0.5" data-id="element-3101" data-mp="1mpfcoki6vh39">
        {/* Product Image */}
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-3102" data-mp="1vqdeqx92hej7" />

        {/* Top badges */}
        <div className="absolute top-2 left-2 flex flex-col gap-1" data-id="element-3103" data-mp="1dld1pa6w1sp0">
          {isOfficialMerch && <div className="flex items-center bg-green-500/90 backdrop-blur-sm text-white text-xs font-semibold px-2 py-0.5 rounded-full shadow-sm" data-id="element-3104" data-mp="1hmy8cdstxaqr">
              <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-3105" data-mp="1mnchy0a2wsqw" />
              Official
            </div>}
          {donationInfo && <div className="flex items-center bg-rose-500/90 backdrop-blur-sm text-white text-xs font-semibold px-2 py-0.5 rounded-full shadow-sm" data-id="element-3106" data-mp="1wjz2sp2enjsx">
              <HeartIcon className="h-3 w-3 mr-1 fill-current" data-id="element-3107" data-mp="20ioco7o8ij7t" />
              {donationInfo.percentage}% donated
            </div>}
        </div>

        {/* Save button */}
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 md:block hidden" data-id="element-3108" data-mp="2a9ssf9lqi83p">
          <SaveToTracker productId={id} data-id="element-3109" data-mp="2k8rsi3sfovf3" />
        </div>
        {/* Save button always visible on mobile */}
        <div className="absolute top-2 right-2 md:hidden" data-id="element-3110" data-mp="1ukcvy878ai7r">
          <SaveToTracker productId={id} data-id="element-3111" data-mp="1ukw1epfoze4w" />
        </div>

        {/* Hover overlay — desktop only */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden md:flex flex-col justify-end p-3" data-id="element-3112" data-mp="1pncp3v2k1bfl">
          <p className="text-white font-semibold text-sm leading-tight line-clamp-2 mb-1 translate-y-1 group-hover:translate-y-0 transition-transform duration-300" data-id="element-3113" data-mp="1zhming38gfrw">
            {title}
          </p>
          <div className="flex items-center justify-between translate-y-1 group-hover:translate-y-0 transition-transform duration-300 delay-75" data-id="element-3114" data-mp="28e3u6kfiefo6">
            <span className="text-white font-bold text-sm" data-id="element-3115" data-mp="2i9xfas7anhhk">
              ${price.toFixed(2)}
            </span>
            {relatedBook ? <span onClick={e => e.preventDefault()} className="text-white/70 text-xs hover:text-white transition-colors flex items-center gap-1" data-id="element-3116" data-mp="sviswejr06p8">
                <BookOpenIcon className="h-3 w-3" data-id="element-3117" data-mp="2zkb23gptuszc" />
                View Book
              </span> : <span className="text-white/60 text-xs truncate max-w-[60%] text-right" data-id="element-3118" data-mp="34kf98g4uibcw">
                {vendor}
              </span>}
          </div>
          {donationInfo && <p className="text-rose-300 text-xs mt-1 truncate translate-y-1 group-hover:translate-y-0 transition-transform duration-300 delay-100" data-id="element-3119" data-mp="2uqq25j4oboxi">
              Supports {donationInfo.nonprofitName}
            </p>}
        </div>

        {/* Mobile persistent bottom strip */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/75 to-transparent px-2.5 pt-6 pb-2 md:hidden" data-id="element-3120" data-mp="26wop5hupmbzt">
          <p className="text-white font-semibold text-xs leading-tight line-clamp-1 mb-0.5" data-id="element-3121" data-mp="53qrn8pzmv8j">
            {title}
          </p>
          <span className="text-white/90 font-bold text-xs" data-id="element-3122" data-mp="a2tv4oqbktee">
            ${price.toFixed(2)}
          </span>
        </div>
      </div>
    </Link>;
};
export default ProductCard;